import React, { ReactNode, useState } from 'react';

import { ReportsListingViewModel } from '../../../types';
import { View } from './View';
import { Edit } from './Edit';

interface Props {
  row: ReportsListingViewModel;
}

export const CloseDateCell = ({ row }: Props) => {
  const [{ viewType, submitMode }, setViewMode] = useState<{
    viewType: 'view' | 'edit';
    submitMode: 'closeDate' | 'estimatedCloseDate';
  }>({
    viewType: 'view',
    submitMode: 'estimatedCloseDate',
  });

  const renderByViewType: Record<'view' | 'edit', ReactNode> = {
    view: <View row={row} setViewMode={setViewMode} />,
    edit: <Edit row={row} submitMode={submitMode} setViewMode={setViewMode} />,
  };

  return renderByViewType[viewType];
};
